import { Component } from '@theme/component';

/** @extends {Component<{opener: HTMLAnchorElement, inlinePlayer: HTMLDivElement, videoTemplate: HTMLTemplateElement}>} */
class ShabaTrustVideo extends Component {
  disconnectedCallback() {
    this.#stop();
    super.disconnectedCallback();
  }
  /** @param {MouseEvent} event */
  open(event) {
    event.preventDefault();
    const { inlinePlayer, videoTemplate } = this.refs;
    let video = this.querySelector('video');
    if (!video) {
      inlinePlayer.append(videoTemplate.content.cloneNode(true));
      video = inlinePlayer.querySelector('video');
    }
    inlinePlayer.hidden = false;
    this.classList.add('shaba-video--playing-inline');
    if (video instanceof HTMLVideoElement) {
      document.querySelectorAll('shaba-trust-video-component video').forEach((other) => {
        if (other instanceof HTMLVideoElement && other !== video) other.pause();
      });
      video.playsInline = true;
      video.preload = 'auto';
      video.autoplay = true;
      video.play().catch(() => {});
      video.tabIndex = 0;
      video.focus({ preventScroll: true });
    }
  }
  #stop() {
    const video = this.querySelector('video');
    if (video instanceof HTMLVideoElement) video.pause();
  }
}
if (!customElements.get('shaba-trust-video-component')) customElements.define('shaba-trust-video-component', ShabaTrustVideo);
